import {
  Toast,
} from 'mint-ui'

export const myToast = (msg) => {
  Toast({
    message: msg,
    position: 'bottom',
    duration: 3000,
  })
}

